import React, { useId } from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '../../../utils/styles';
import PromoGradientDefs from '../../../utils/styles/PromoGradientDefs';

const CheckedIcon = React.memo(({ isEnriched = false, ...props }) => {
    const theme = useTheme();
    const reactId = useId();
    const gradientId = `promo-gradient-${reactId.replace(/:/g, '')}`;
    const fill = isEnriched ? `url(#${gradientId})` : theme.colors.actionMajor[500];

    return (
        <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            {isEnriched && <PromoGradientDefs id={gradientId} />}
            <path
                fill={fill}
                fillRule="evenodd"
                d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
                clipRule="evenodd"
            />
        </svg>
    );
});

CheckedIcon.displayName = 'CheckedIcon';

CheckedIcon.propTypes = {
    /** When true, fills the SVG with the promotional gradient */
    isEnriched: PropTypes.bool,
};

export default CheckedIcon;
